import { memo, useCallback } from 'react';

import { getSizeDimensionsLabel, type SavedSize } from '@air/feature-saved-sizes/utils';
import { Label } from '@air/primitive-label';
import { Select, SelectContent, SelectItem, SelectTrigger } from '@air/primitive-select';

export type ExportSavedSizeSelectProps = {
  onSelect: (savedSize: SavedSize) => void;
  selectedId: string;
  sizePresets: SavedSize[];
};

export const ExportSavedSizeSelect = memo(({ onSelect, selectedId, sizePresets }: ExportSavedSizeSelectProps) => {
  const handleValueChange = useCallback(
    (value: string) => {
      const savedSize = sizePresets.find((preset) => preset.id === value);

      if (!savedSize) {
        return;
      }

      onSelect(savedSize);
    },
    [onSelect, sizePresets],
  );

  return (
    <div className="flex flex-col" data-testid="EXPORT_SAVED_SIZE_SELECT">
      <Label className="mb-1" htmlFor="export-saved-size">
        Saved size
      </Label>
      <Select onValueChange={handleValueChange} value={selectedId}>
        <SelectTrigger className="w-full" id="export-saved-size" placeholder="Choose a saved size" />
        <SelectContent>
          {sizePresets.map((savedSize) => (
            <SelectItem data-saved-size-id={savedSize.id} key={savedSize.id} value={savedSize.id}>
              {savedSize.name} ({getSizeDimensionsLabel(savedSize)})
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
});

ExportSavedSizeSelect.displayName = 'ExportSavedSizeSelect';
